import * as React from 'react'
import { useState, useEffect, useRef, useMemo } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import {
  Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid, scopedCssBaselineClasses, Container, Stack,
  FormControlLabel,
  CircularProgress,
  Checkbox,
} from '@mui/material'
import { findCode, printVariable, sanitizeFilename } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import useAlert from '@hooks/useAlert'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import Box from '@mui/material/Box'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import '@scss/App.scss'
import consoleLogger from 'react-terminal-logger/console-logger'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles';
import { LineCart, LineChart, } from '@mui/x-charts/LineChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import { useAnimate, useAnimateBar, useDrawingArea } from '@mui/x-charts/hooks';
import { PiecewiseColorLegend } from '@mui/x-charts/ChartsLegend';
import { interpolateObject } from '@mui/x-charts-vendor/d3-interpolate';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManagerSurveyPartIndi from './manager-survey.part.indi'
import * as ExcelJS from 'exceljs'
import ExcelExporter from '@components/ExcelExporter'
import { transformToMatrix, transformToMatrix2 } from './manager-survey.part.indi'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
// import { FixedSizeList } from 'react-window'
// import FixedSizeList from 'react-window/'
import { VariableSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer';

const ManagerSurveyPartStat = ({ record, dialogHandler, tabValue, callback }) => {
  const [quests, set_quests] = useState([])
  const [originSurveySum, set_originSurveySum] = useState([])
  const [openSnackbar] = useSnackbar()
  const [replUserCnt, set_replUserCnt] = useState()
  const [topicUserCnt, set_topicUserCnt] = useState()
  const [originSubjRepls, set_originSubjRepls] = useState([])
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const detailHandler = useState(false)
  const [isLoading, set_isLoading] = useState(true)
  const [smst, set_smst] = useState({})
  const lecturesOriginRef = useRef([])
  const [originLectures, set_originLectures] = useState([])
  const [originRepls, set_originRepls] = useState([])
  const schola = useSelector(state => state.scholaReducer);
  const [stats, set_stats] = useState({})
  const listRef = useRef(null)
  const rowHeights = useRef({})
  const [isDepartment, set_isDepartment] = useState(true)
  const [selectionId, set_selectionId] = useState(0)

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      dialogHandler[1](false)
    }
  }

  const groupedLectures = useMemo(() => {
    return Object.values(
      originLectures.reduce((acc, cur) => {
        if (!acc[cur.userId]) {
          acc[cur.userId] = {
            id: Date.now() + Math.random(),
            userId: cur.userId,
            smstId: cur.smstId,
            user: cur.user,
            myLectures: [],
            prcNums: [],
            titles: new Set() // 중복 제목 제거용
          }
        }
        acc[cur.userId].myLectures.push(cur.id)
        acc[cur.userId].prcNums.push(cur.prcNum)
        acc[cur.userId].titles.add(cur.title)

        return acc
      }, {})
    ).map(group => {
      const titleArray = Array.from(group.titles)
      let commonPrefix = titleArray[0] || '알 수 없음'

      for (let i = 1; i < titleArray.length; i++) {
        let j = 0
        while (j < commonPrefix.length && j < titleArray[i].length && commonPrefix[j] === titleArray[i][j]) {
          j++
        }
        commonPrefix = commonPrefix.substring(0, j)
      }

      const finalTitle = commonPrefix.trim().length > 1
        ? commonPrefix.trim()
        : titleArray.join(', ')

      return {
        id: group.id,
        userId: group.userId,
        smstId: group.smstId,
        myLectures: group.myLectures,
        user: group.user,
        prcNum: group.prcNums.reduce((acc, cur) => acc + cur, 0),
        title: finalTitle
      }
    }).sort((a, b) => a.title.localeCompare(b.title))

  }, [originLectures])

  const lectures = useMemo(() => {
    const baseLectures = isDepartment ? groupedLectures : originLectures
    if (selectionId == 0) return baseLectures
    return baseLectures.filter(r => r.id === selectionId)
  }, [groupedLectures, isDepartment, selectionId])

  const lectureToGroupMap = useMemo(() => {
    return lectures.reduce((map, group) => {
      group.myLectures?.forEach(lectureId => {
        map[lectureId] = group.id
      })
      return map
    }, {})
  }, [lectures])

  const selLectures = useMemo(() => {
    return isDepartment ? groupedLectures : originLectures
  }, [groupedLectures, isDepartment])

  const flatListItems = useMemo(() => {
    const items = [];
    if (lectures.length > 0 && quests.length > 0) {
      lectures.forEach((lecture) => {
        items.push({ type: 'HEADER', lecture });
        quests.forEach((quest) => {
          items.push({ type: 'QUEST', lecture, quest });
        });
      });
    }

    return items;
  }, [lectures, quests])

  const lectureStudents = useMemo(() => {
    return originRepls.reduce((acc, curr) => {
      const { lectureId, studentId } = curr
      if (!acc[lectureId]) {
        acc[lectureId] = new Set()
      }
      acc[lectureId].add(studentId)

      return acc
    }, {})

  }, [originRepls])

  

  const repls = useMemo(() => {
    if (!isDepartment) {
      return originRepls
    }
    else {

      return originRepls.map(d => ({
        ...d,
        lectureId: lectureToGroupMap[d.lectureId] || d.lectureId
      }))
    }
  }, [originRepls, isDepartment])

  const ansCntByLecture = useMemo(() => {

    let ansCntMap

    if (!isDepartment) {
      ansCntMap = Object.entries(lectureStudents).reduce((acc, [lectureId, studentSet]) => {
        acc[lectureId] = studentSet.size
        return acc
      }, {})
    }
    else {
      ansCntMap = lectures.reduce((acc, group) => {
        acc[group.id] = group.myLectures.reduce((sum, lectureId) => {
          return sum + (lectureStudents[lectureId]?.size || 0)
        }, 0)
        return acc
      }, {})
    }
    return ansCntMap

  }, [lectureStudents, isDepartment])

  const subjRepls = useMemo(() => {
    if (!isDepartment) {
      return originSubjRepls
    }
    else {

      return originSubjRepls.map(repl => ({
        ...repl,
        lectureId: lectureToGroupMap[repl.lectureId] || repl.lectureId
      }))
    }
  }, [originSubjRepls, isDepartment])

  const surveySum = useMemo(() => {
    if (!isDepartment) {
      return originSurveySum
    }
    else {
      return originSurveySum.map(d => ({
        ...d,
        lectureId: lectureToGroupMap[d.lectureId] || d.lectureId
      }))

    }
  }, [originSurveySum, isDepartment])

  const set_rowHeight = (index, size) => {
    if (rowHeights.current[index] !== size) {
      rowHeights.current[index] = size
      listRef.current?.resetAfterIndex(index)
    }
  }

  const getItemSize = (index) => rowHeights.current[index] || 100

  // const getItemSize = (index) => {
  //   const item = flatListItems[index];
  //   return item.type === 'HEADER' ? 300 : 300 // 헤더는 짧게, 질문은 높게
  // }

  const MyPie = ({ lectureId, questId }) => {
    const rows = surveySum.filter(r => r.lectureId === lectureId && r.questId === questId)
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0)

    const data =
      quests.find(q => q.id === questId)?.anss?.map(ans => {
        // const ansCnt = rows.find(r => r.ansId === ans.id)?.ansCnt ?? 0
        const ansCnt = rows.filter(r => r.ansId === ans.id).reduce((acc, cur) => acc + cur.ansCnt, 0)
        const isNoData = total === 0
        const dataItem = {
          id: ans.id,
          value: isNoData ? 1 : ansCnt,
          label: ans.txt,
          formattedLabel: isNoData ? '0 (0%)' : `${ansCnt} ( ${((ansCnt / total) * 100).toFixed(1)}%)`
        }

        if (isNoData) {
          dataItem.color = '#eeeeee';
        }
        return dataItem
      })


    const series = [
      {
        data: data,
        arcLabel: (item) => item.formattedLabel,
        arcLabelMinAngle: 35, // Only show label if slice is big enough
        highlightScope: { faded: 'global', highlighted: 'item' },
      },
    ]

    return (
      <>
        <Typography variant='body2'>응답:{total}</Typography>
        <PieChart
          series={series}
          sx={{
            [`& .MuiPieArcLabel-root`]: {
              fill: 'white',
              fontWeight: 'bold',
              fontSize: 12,
            },
          }}
          width={500}
          height={200}
        />
        {/* {
          total == 0 ? (
            <Typography>이 질문에 응답이 없습니다.</Typography>
          ) : null
        } */}
      </>

    )
  }



  const MyBar = ({ lectureId, questId }) => {
    const rows = surveySum.filter(r => r.lectureId === lectureId && r.questId === questId)
    if (!surveySum.length || rows.length === 0) {
      return <div style={{ height: 200 }}>Loading Chart Data...</div>;
    }
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0);
    const answers = quests.find(q => q.id === questId)?.anss || [];

    if (answers.length === 0) return null
    const axisData = answers.map(ans => ans.txt)

    // const axisData = 
    //   quests.find(q => q.id === questId)?.anss?.map(ans => {
    //     return ans.txt
    //   })

    // const axisData = rows.map(r => {
    //   // 답변 하나가 한 그룹
    //   const txt = quests.find(q => q.id === questId)?.anss?.find(a => a.id === r.ansId)?.txt
    //   return txt || '삭제된 선택지'
    //   // return quests.find(q => q.id === questId)?.anss?.find(a => a.id === r.ansId)?.txt
    // })

    const seriesData = [
      {
        data: answers.map(ans => {
          // const found = rows.find(r => r.ansId === ans.id);
          // return found ? found.ansCnt : 0
          const ansCnt = rows.filter(r => r.ansId === ans.id).reduce((acc, cur) => acc + cur.ansCnt, 0)
          return ansCnt
        }),

        // rows.map(r => r.ansCnt),

        // label: '응답수' 
        valueFormatter: (value) => {
          const percent = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
          return `${value} views (${percent}%)`;
        },
      }
    ]

    return (
      <>
        <Typography variant='body2'>응답:{total}</Typography>
        <BarChart
          yAxis={[{
            scaleType: 'band',
            data: axisData,
          }]}
          xAxis={[{
            type: 'number',
            // Force the chart to show a bit of space before the first bar
            // min: -0.01, 
            // Ensure the max value has room for the text labels
            // max: total > 0 ? total + (total * 0.2) : 10 
          }]}
          layout="horizontal"
          series={seriesData}
          barLabel={(item) => {
            if (item.value === 0) return null;
            const percent = total > 0 ? ((item.value / total) * 100).toFixed(0) : 0;
            return `${item.value} (${percent}%)`;
          }}

          height={200}
          width={500}
          margin={{ left: 150, right: 80 }}
        />
        {/* {
          total === 0 ? (
             <Typography>이 질문에 응답이 없습니다.</Typography>
          ) : null
        } */}
      </>

    )
  }
  const MyAccordion = ({ lectureId, questId }) => {
    const rows = surveySum.filter(r => r.lectureId === lectureId && r.questId === questId)
    const total = rows.reduce((sum, r) => sum + r.ansCnt, 0);
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }} gap={1}>
        <Typography variant='body2'>응답:{total}</Typography>
        <Grid container>
          <Grid item xs={12}>
            <Accordion
              sx={{ zIndex: 9999 }}
            >
              <AccordionSummary
                id={`repl-${questId}`}
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: '#fafafa', // 필요시 배경색 살짝 추가
                }}
              >
                응답내용
              </AccordionSummary>
              <AccordionDetails>
                {
                  subjRepls.filter(r => r.lectureId === lectureId && r.questId === questId).map((repl) => (
                    <Typography key={`repl-${lectureId}-${questId}-${repl.id}`}>{repl.txt}</Typography>
                  ))
                }
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>

      </Box>

    )
  }



  const VirtualRow = ({ index, style }) => {
    const item = flatListItems[index]
    const rowRef = useRef()
    useEffect(() => {
      if (rowRef.current) {
        // 렌더링 직후 실제 높이 측정
        const height = rowRef.current.getBoundingClientRect().height + 30
        set_rowHeight(index, height)
      }
    }, [index])

    return (
      <div style={style}>
        <div ref={rowRef}>
          {item.type === 'HEADER' ? (
            <div>
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <LabelOutlinedIcon />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  {item.lecture.title}
                </Typography>
              </Stack>
              <Stack>
                {
                  (() => {
                    if (record.modeCode === 'M000') {
                      return null
                    }

                    const lectureAnsCnt = ansCntByLecture[item.lecture.id] ?? 0
                    const targetCnt = item.lecture.prcNum
                    let ratio = 0.0
                    if (targetCnt > 0) {
                      ratio = (100 * Number(lectureAnsCnt) / Number(targetCnt)).toFixed(1)
                    }
                    return (
                      <Typography variant='body2' sx={{ fontWeight: 'bold' }}>대상자: {targetCnt} 응답자: {lectureAnsCnt} 비율: {ratio} %</Typography>
                    )

                  })()
                }

              </Stack>

              <Stack>
                {
                  (() => {
                    if (record.modeCode === 'M000') {
                      return null
                    }

                    const lectureStats = Object.keys(stats.byLecture)
                      .filter((key) => key.startsWith(`${item.lecture.id}_`))
                      .map((key) => {
                        const txt = key.split('_')[1]
                        return { txt, count: stats.byLecture[key] }
                      })
                    const tcnt = lectureStats.reduce((acc, cur) => acc + cur.count, 0)

                    return (
                      <>
                        <Grid container spacing={0}>
                          <Grid item xs={4}><Typography variant='body2' sx={{ fontWeight: 'bold' }}>요약</Typography></Grid>
                          <Grid item xs={4}><Typography variant='body2' sx={{ fontWeight: 'bold' }}>응답</Typography></Grid>
                          <Grid item xs={4}><Typography variant='body2' sx={{ fontWeight: 'bold' }}>비율</Typography></Grid>
                        </Grid>
                        <Divider />
                        <Grid container spacing={0}>
                          {
                            lectureStats.map(stat => {

                              let ratio = 0.0
                              if (tcnt > 0) {
                                ratio = (100 * stat.count / tcnt).toFixed(1)
                              }
                              return (
                                <>
                                  <Grid item xs={4}><Typography variant='body2'>{stat.txt}</Typography></Grid>
                                  <Grid item xs={4}><Typography variant='body2'>{stat.count}</Typography></Grid>
                                  <Grid item xs={4}><Typography variant='body2'>{ratio} %</Typography></Grid>
                                </>
                              )

                            })
                          }
                        </Grid>

                      </>

                    )

                  })()
                }
              </Stack>
            </div>

          ) : (
            <div key={`${item.lecture.id}-${item.quest.id}`}>
              <Typography style={{ fontWeight: 'bold' }}>{`Q.${item.quest.sqNum} ${item.quest.txt}`}</Typography>
              {item.quest.questCode === 'Q000' ? (
                <MyPie lectureId={item.lecture.id} questId={item.quest.id} />
              ) : item.quest.questCode === 'Q001' ? (
                <MyBar lectureId={item.lecture.id} questId={item.quest.id} />
              ) : (
                <MyAccordion lectureId={item.lecture.id} questId={item.quest.id} />
              )}
            </div>
          )}
        </div>
      </div>
    )
  }

  const fillSheet1 = (workbook) => {
    const lectureStart = 1
    const questStart = 1
    const gubunStart = 2
    const ansStart = 3
    const exporter = new ExcelExporter(workbook, "분석")

    const title = `${record.title}`
    const term = `설문기간: ${record.startTime.substr(0, 10)} ~ ${record.endTime.substr(0, 10)}`
    let smstName = '대상 강좌 기수: '
    if (smst?.id > 0) {
      smstName += `${smst.year} ${smst.gisu}`
    }
    else {
      smstName += `없음`
    }


    let replRatio = 0
    if (topicUserCnt > 0) {
      replRatio = (100 * Number(replUserCnt) / Number(topicUserCnt)).toFixed(1)
    }

    const replStat = `전체 대상자:${topicUserCnt} 전체 응답자:${replUserCnt} 비율:${replRatio} %`
    const headers = ['문항', '구분', '응답항목/내용', '응답', '비율']
    exporter.setValue(`${schola.name}`).nextRow()
    exporter.setValue(title).nextRow()
    exporter.setValue(term).nextRow()
    exporter.setValue(smstName).nextRow()
    exporter.setValue(replStat).nextRow()
    if (record.modeCode !== 'M000') {

      const statsAll = stats?.all || {}
      const tcnt = Object.values(statsAll).reduce((acc, curr) => acc + curr, 0) || 0
      exporter.jumpTo(exporter.rownum, 3)
      exporter.setValue('전체요약').nextCol()
      exporter.setValue('전체응답').nextCol()
      exporter.setValue('비율').nextCol()
      exporter.jumpTo(exporter.rownum + 1, 3)
      Object.entries(stats.all || {}).forEach(([txt, count]) => {
        const ratio = tcnt > 0 ? ((count / tcnt) * 100).toFixed(1) : 0
        exporter.setValue(txt).nextCol()
        exporter.setValue(count).nextCol()
        exporter.setValue(`${ratio} %`).nextCol()
        exporter.jumpTo(exporter.rownum + 1, 3)
      })
    }

    exporter.jumpTo(exporter.rownum + 1, 1)
    // exporter.setValue('강좌명').nextCol()
    // exporter.setValue('문항').nextCol()
    // exporter.setValue('구분').nextCol()
    // exporter.setValue('응답항목/내용').nextCol()
    // exporter.setValue('응답수').nextCol()
    // exporter.setValue('비율').nextCol()
    // exporter.jumpTo(exporter.rownum + 1, 1)

    lectures.forEach((lecture, lidx) => {
      const lectureTitle = `■ ${lecture.title}`

      let lecureSummary = lectureTitle
      if (lecture.id > 0) {
        const lectureTargetCnt = lecture.prcNum
        const teacherName = lecture.user?.name ?? '없음'
        const lectureAnsCnt = ansCntByLecture[lecture.id] ?? 0
        let lectureReplRaio = 0
        if (lectureTargetCnt > 0) {
          lectureReplRaio = (100 * Number(lectureAnsCnt) / Number(lectureTargetCnt)).toFixed(1)
        }
        lecureSummary += `(강사명:${teacherName} 대상자: ${lectureTargetCnt} 응답자:${lectureAnsCnt} 비율: ${lectureReplRaio} %)`
      }

      // exporter.setValue(`${lecture.title}`).nextCol()
      exporter.setValue(`${lecureSummary}`)
      if (record.modeCode != 'M000') {
        const lectureStats = Object.keys(stats.byLecture)
          .filter((key) => key.startsWith(`${lecture.id}_`))
          .map((key) => {
            const txt = key.split('_')[1]
            return { txt, count: stats.byLecture[key] }
          })
        const tcnt = lectureStats.reduce((acc, cur) => acc + cur.count, 0)
        exporter.jumpTo(exporter.rownum + 1, 3)
        exporter.setValue('요약').nextCol()
        exporter.setValue('응답').nextCol()
        exporter.setValue('비율').nextCol()
        exporter.jumpTo(exporter.rownum + 1, 3)

        lectureStats.forEach(stat => {
          const ratio = tcnt !== 0 ? (100 * stat.count / tcnt).toFixed(1) : 0
          exporter.setValue(stat.txt).nextCol()
          exporter.setValue(stat.count).nextCol()
          exporter.setValue(`${ratio} %`).nextCol()
          exporter.jumpTo(exporter.rownum + 1, 3)
        })
      }
      exporter.jumpTo(exporter.rownum + 1, 1)

      headers.forEach(h => {
        exporter.setValue(h).nextCol()
      })
      exporter.jumpTo(exporter.rownum + 1, 1)

      quests.forEach((quest, qidx) => {
        exporter.setValue(`Q.${quest.sqNum} ${quest.txt}`).nextCol()
        const gubun = quest.questCode === 'Q002' ? '주관식' : quest.questCode === 'Q000' ? '객관식(단)' : '객관식(복)'
        exporter.setValue(`${gubun}`).nextCol()
        if (quest.questCode !== 'Q002') {
          const questAnsRows = surveySum.filter(r => r.lectureId === lecture.id && r.questId === quest.id)
          const questAnsCount = questAnsRows.reduce((acc, cur) => { return acc + cur.ansCnt }, 0)
          quest.anss.forEach((ans, aidx) => {
            // 객관식
            exporter.setValue(`${ans.txt}`).nextCol()
            const ansCnt = surveySum.find(r => r.lectureId === lecture.id && r.questId === quest.id && r.ansId === ans.id)?.ansCnt ?? 0

            exporter.setValue(`${ansCnt}`).nextCol()
            const ratio = questAnsCount == 0 ? 0 : (100 * Number(ansCnt) / Number(questAnsCount)).toFixed(1)
            exporter.setValue(`${ratio} %`).nextCol()
            exporter.jumpTo(exporter.rownum + 1, ansStart)
          })
        }
        else {
          const srepls = subjRepls.filter(r => r.lectureId === lecture.id && r.questId === quest.id)
          srepls.forEach((repl, ridx) => {
            exporter.setValue(`${repl.txt}`)
            exporter.nextRow()
          })
        }
        exporter.jumpTo(exporter.rownum, questStart)
      })

      exporter.jumpTo(exporter.rownum + 1, lectureStart)
    })

    const columnA = exporter.sheet.getColumn(1); // 1번 컬럼 (A열)
    let maxLen = 0;

    columnA.eachCell({ includeEmpty: true }, (cell) => {
      const cellLength = cell.value ? cell.value.toString().length : 10;
      if (cellLength > maxLen) {
        maxLen = cellLength;
      }
    })
    columnA.width = maxLen < 10 ? 10 : maxLen + 2;
  }

  const fillSheet2 = (workbook, data) => {
    console.log('data=>', data)
    const { headers, rows } = data
    const exporter = new ExcelExporter(workbook, "상세")
    exporter.setValue('No').nextCol()
    // exporter.setValue('전화번호').nextCol()
    exporter.setValue('힉년').nextCol()
    exporter.setValue('반').nextCol()
    exporter.setValue('번호').nextCol()
    exporter.setValue('학생명').nextCol()
    exporter.setValue('보호자전화번호').nextCol()
    exporter.setValue('강좌명').nextCol()

    headers.forEach(header => {
      exporter.setValue(header).nextCol()
    })

    exporter.jumpTo(exporter.rownum + 1, 1)

    const printRow = (row, rowIdx) => {
      exporter.setValue(rowIdx + 1).nextCol()
      exporter.setValue(row.student?.grade ?? '-').nextCol()
      exporter.setValue(row.student?.className ?? '-').nextCol()
      exporter.setValue(row.student?.classNum ?? '-').nextCol()
      exporter.setValue(row.student?.name ?? '-').nextCol()
      exporter.setValue(row.user?.phone ?? '-').nextCol()
      exporter.setValue(row.lecture?.title ?? '-').nextCol()
      row.data.forEach((cell, cellIdx) => {
        exporter.setValue(cell.value).nextCol()
      })

      exporter.jumpTo(exporter.rownum + 1, 1)
    }

    // const lectureIds = originLectures.map(r => r.id)
    const lectureIds = lectures.map(r => r.id)

    let targetRows = rows
    if (record.modeCode === 'M001' && record.smstId > 0) {
      targetRows = rows.filter(r => lectureIds.includes(r.lecture?.id))
    }

    targetRows.forEach((row, rowIdx) => {
      printRow(row, rowIdx)
    })
  }

  const handleDownload = async () => {
    const data = await fetchSurveyDetail2()
    if (!data) {
      return
    }

    const workbook = new ExcelJS.Workbook()
    fillSheet1(workbook)
    fillSheet2(workbook, data)


    workbook.xlsx.writeBuffer().then(buffer => {
      // let filename = `${schola.name}_${record.title}`
      let filename = `${record.title}`
      if (lectures.length === 1) {
        filename += `_${lectures[0].title}`
      }


      filename += `.xlsx`
      filename = sanitizeFilename(filename)

      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    })
  }

  const fetchSurveyDetail = async () => {
    const url = `/survey/detail/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const surveyDetail = JSON.parse(repMessage.surveyDetail)

    const { headers, rows } = transformToMatrix(surveyDetail)
    return ({
      headers: headers,
      rows: rows,
    })
  }

  const fetchSurveyDetail2 = async () => {
    const url = `/survey/detail2/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const originData = JSON.parse(repMessage.surveyDetail)
    console.log('originData=>', originData)
    let surveyDetail = originData
    
    
    if (isDepartment) {
      const groupLookup = lectures.reduce((acc, group) => {
        acc[group.id] = group
        return acc
      }, {})
      
      const newLectureMap = Object.entries(originData.lectureMap).reduce((acc, [key, value]) => {
        const newKey = lectureToGroupMap[key] || key
        const title = groupLookup[newKey]?.title || '알 수 없음'
        value.id = newKey
        value.title = title
        acc[newKey] = value
        return acc
      }, {})

      const newReplsMap = Object.entries(originData.replsMap).reduce((acc, [key, value]) => {
        const parts = key.split('_')
        if (parts.length >= 2) {
          const originalLectureId = parts[1]
          const newLectureId = lectureToGroupMap[originalLectureId] || originalLectureId
          parts[1] = newLectureId
          const newKey = parts.join('_')
          acc[newKey] = value
        } else {
          acc[key] = value
        }
        return acc
      }, {})

      surveyDetail = {
        ...originData,
        lectureMap: newLectureMap,
        replsMap: newReplsMap
      }
    }
    
    const { headers, rows } = transformToMatrix2(surveyDetail)
    console.log('rows=>', rows)
    return ({
      headers: headers,
      rows: rows,
    })
  }

  const fetchQuests = async () => {
    if (lectures.length == 0) {
      return
    }

    if (record.id === -1) {
      return
    }

    const url = `/survey/${record.id}`
    openIndicator()
    const resp = await WebService.get(url, {
      useYn: 'A'
    })
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    if (records?.length > 0) {
      const quests = records[0].quests
      // quests.forEach((quest) => {
      //   quest.anss.forEach()
      // })
      set_quests(quests)
    }
  }

  const calcStats = () => {
    const ansMap = {}
    const allTxts = [] // 전체 답변 항목 목록

    quests.forEach((q) => {
      q.anss.forEach((a) => {
        if (a.id > 0) {
          ansMap[`${q.id}_${a.id}`] = a.txt
          if (!allTxts.includes(a.txt)) {
            allTxts.push(a.txt)
          }
        }

      })
    })

    const stats = {
      byLecture: {},
      all: {}
    }

    // 모든 항목을 0으로 초기화
    allTxts.forEach(txt => {
      stats.all[txt] = 0
      lectures.forEach(lec => {
        stats.byLecture[`${lec.id}_${txt}`] = 0
      })
    })


    // 실제 데이터 카운팅
    repls.forEach((repl) => {
      const { lectureId, questId, ansId } = repl
      if (ansId > 0) {
        const txt = ansMap[`${questId}_${ansId}`]

        if (txt) {
          const lecKey = `${lectureId}_${txt}`
          stats.byLecture[lecKey] = (stats.byLecture[lecKey] || 0) + 1
          stats.all[txt] = (stats.all[txt] || 0) + 1
        }
      }

    })
    console.log('stats=>', stats)
    set_stats(stats)

    // return stats
  }

  const fetchSum = async () => {
    const url = `/survey/sum/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const replUserCnt = Number(repMessage.replUserCnt)
    const topicUserCnt = Number(repMessage.topicUserCnt)
    const originSubjRepls = JSON.parse(repMessage.subjRepls)
    const originRepls = JSON.parse(repMessage.repls)


    set_replUserCnt(replUserCnt)
    set_topicUserCnt(topicUserCnt)

    set_originRepls(originRepls)

    set_originSubjRepls(originSubjRepls)
    set_originSurveySum(records)

    set_isLoading(false)
  }

  const fetchSmst = async () => {
    if (record?.modeCode === 'M001' && record?.smstId > 0) {
      const url = `/smst/id/${record.smstId}`
      const resp = await WebService.get(url)
      if (resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      const repMessage = JSON.parse(resp.repMessage)
      const smst = JSON.parse(repMessage.record)
      set_smst(smst)
    }
  }

  const fetchLectures = async () => {
    if (record?.modeCode === 'M001' && record?.smstId > 0) {
      const url = `/lecture/array/smst/${record.smstId}`
      const resp = await WebService.get(url)
      if (resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      const repMessage = JSON.parse(resp.repMessage)
      const lectures = JSON.parse(repMessage.records)
      lecturesOriginRef.current = JSON.parse(JSON.stringify(lectures))
      set_originLectures(lectures)

    }
    else {
      set_originLectures([{
        id: -1,
        title: '일반 설문조사'
      }])
    }
  }

  const onLoad = async () => {
    // await fetchLectures()
    // await fetchQuests()
    // await fetchSum()
  }


  useEffect(() => {
    (async () => {
      await fetchSmst()
      await fetchLectures()
    })()

  }, [])

  useEffect(() => {
    if (quests.length == 0) {
      fetchQuests()
    }

  }, [lectures])

  useEffect(() => {
    fetchSum()

  }, [quests])

  useEffect(() => {
    calcStats()
  }, [surveySum])

  // useEffect(() => {
  //   onLoad()
  // }, [])

  // if(isLoading) {
  //   return <></>
  // }

  return (
    <Fragment>
      <div>
        {renderIndicator()}
        {renderAlert()}
        {detailHandler[0] ? (<ManagerSurveyPartIndi record={record} dialogHandler={detailHandler} callback={onLoad} />) : null}
      </div>
      <Dialog open={dialogHandler[0]} onClose={handleClose} fullScreen>
        <DialogTitle>
          <Grid container>
            <Grid item xs></Grid>
            <Grid item xs={10}>
              <Box className={'center'}>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  {schola.name}
                </Typography>

                <Typography variant="h5" sx={{ fontWeight: 'bold' }} align="center">
                  {record.title}
                </Typography>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  분석
                </Typography>

              </Box>
            </Grid>
            <Grid item xs style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
          <Container sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Stack direction="column" spacing={2} sx={{ display: 'flex', alignItem: 'center', width: '100%', mt: 1 }}>
              <Stack sx={{ minHeight: '100px' }}>
                {
                  <Box style={{ display: 'flex', alignItems: 'center' }} gap={2}>
                    <PeopleAltOutlinedIcon />
                    <Box>
                      {
                        (() => {
                          let ratio
                          if (topicUserCnt !== undefined) {
                            if (topicUserCnt > 0) {
                              ratio = (100 * Number(replUserCnt) / Number(topicUserCnt)).toFixed(1)
                            }
                            else {
                              ratio = 0.0
                            }
                          }

                          return (
                            <>
                              <Typography style={{ fontWeight: 'bold' }} variant={'h6'}>전체 대상자: {topicUserCnt}</Typography>
                              <Typography style={{ fontWeight: 'bold' }} variant={'h6'}>전체 응답자: {replUserCnt}</Typography>
                              <Typography style={{ fontWeight: 'bold' }} variant={'h6'}>비율: {ratio} %</Typography>

                            </>

                          )
                        })()
                      }

                    </Box>


                  </Box>
                }
              </Stack>
              {
                (() => {
                  if (record.modeCode === 'M000') {
                    return null
                  }
                  return (
                    <Stack>
                      <Grid container spacing={0}>
                        <Grid item xs={4}><Typography variant='body2' sx={{ fontWeight: 'bold' }}>전체요약</Typography></Grid>
                        <Grid item xs={4}><Typography variant='body2' sx={{ fontWeight: 'bold' }}>전체응답</Typography></Grid>
                        <Grid item xs={4}><Typography variant='body2' sx={{ fontWeight: 'bold' }}>비율</Typography></Grid>
                      </Grid>
                      <Divider />
                      <Grid container spacing={0}>
                        {
                          (() => {
                            const statsAll = stats?.all || {}
                            const tcnt = Object.values(statsAll).reduce((acc, curr) => acc + curr, 0) || 0
                            return Object.entries(stats.all || {}).map(([txt, count]) => {
                              const ratio = tcnt > 0 ? ((count / tcnt) * 100).toFixed(1) : 0

                              return (
                                <React.Fragment key={txt}>
                                  <Grid item xs={4}><Typography variant='body2'>{txt}</Typography></Grid>
                                  <Grid item xs={4}><Typography variant='body2'>{count}</Typography></Grid>
                                  <Grid item xs={4}><Typography variant='body2'>{ratio} %</Typography></Grid>
                                </React.Fragment>
                              )
                            })
                          })()
                        }
                      </Grid>
                      <Divider />
                    </Stack>
                  )
                })()
              }


              <Stack>
                <Grid container spacing={1}>
                  {
                    record?.modeCode === 'M001' ? (
                      <>
                        <Grid item xs={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                onChange={async (e) => {
                                  set_isDepartment(!isDepartment)
                                  set_selectionId(0)
                                }}
                                checked={isDepartment}
                              />
                            }
                            label={'강사별 모아보기'}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <FormControl fullWidth size="small" >
                            <InputLabel id='lecture'>
                              강좌선택
                            </InputLabel>
                            <Select
                              fullWidth
                              labelId='lecture'
                              required
                              label='상태'
                              value={selectionId}
                              onChange={(e) => {
                                set_selectionId(e.target.value)
                              }}>
                              <MenuItem value={0}>
                                전체
                              </MenuItem>
                              {
                                selLectures?.map((l, index) => (
                                  <MenuItem key={index} value={l.id}>
                                    {l.title}
                                  </MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>
                        </Grid>
                      </>

                    ) : null
                  }
                  <Grid item xs={2}>
                    <Button
                      startIcon={<FileDownloadOutlinedIcon />}
                      size='md'
                      onClick={() => {
                        handleDownload()
                      }}
                    >
                      다운로드
                    </Button>
                  </Grid>
                </Grid>

              </Stack>

            </Stack>
            <Stack sx={{ flex: 1, display: 'flex', flexDirection: 'column', mt: 5 }}>
              <AutoSizer>
                {({ height, width }) => (
                  <List
                    ref={listRef}
                    height={height}
                    width={width}
                    itemCount={flatListItems.length}
                    itemSize={getItemSize}
                  >
                    {VirtualRow}
                  </List>
                )}
              </AutoSizer>
            </Stack>

          </Container>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleClose}>닫기</Button>
        </DialogActions>
      </Dialog>

    </Fragment>
  )
}

export default ManagerSurveyPartStat